"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { findResume, type ResumeTarget } from "@/lib/breach/resume"

/** Shown in the site nav only when this browser holds saved progress. Hidden while already inside the tool. */
export function ResumeButton() {
  const [target, setTarget] = useState<ResumeTarget | null>(null)
  const path = usePathname()
  useEffect(() => {
    const read = () => setTarget(findResume())
    read()
    window.addEventListener("storage", read)
    window.addEventListener("focus", read)
    return () => { window.removeEventListener("storage", read); window.removeEventListener("focus", read) }
  }, [path])
  if (!target || path.startsWith("/incident") || (target.kind === "draft" && path.startsWith("/start"))) return null
  return (
    <Link href={target.href} title={`Saved in this browser: ${target.label}`}
      className="rounded-md bg-accent-solid px-3 py-1.5 text-sm font-semibold text-accent-solid-foreground hover:bg-accent-solid/90">
      {target.kind === "draft" ? "Resume questions" : "Resume my plan"}
    </Link>
  )
}
